import { useNostoAppState } from "@nosto/search-js/preact/hooks"
import style from "./NoResults.module.css"

/**
 * Rendered when `ContentWrapper` decides there are no renderable products.
 * When Nosto's raw `products.total` is positive but every hit was stripped
 * (e.g. unavailable products, market filter, style-family dedupe collapse),
 * the catalog has matches that simply can't be sold — show a more accurate
 * message than the generic "No results found".
 */
export default function NoResults() {
  const rawTotal = useNostoAppState(state => state.response?.products?.total ?? 0)
  const message = rawTotal > 0 ? "Matching products are unavailable" : "No results found"
  return (
    <div className={style.container}>
      <div className={style.content}>{message}</div>
    </div>
  )
}
